import {
  ACTIVO_ZONAS_RESTAURANTE,
  CLEAR_ALL,
  GETALL_ZONAS_RESTAURANTE,
  LOADING_GETALL_ZONAS_RESTAURANTE,
  PARAMS_ZONAS_RESTAURANTE,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const zonasRestauranteReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_ZONAS_RESTAURANTE:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case ACTIVO_ZONAS_RESTAURANTE:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_ZONAS_RESTAURANTE:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_ZONAS_RESTAURANTE:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
